import { render } from "./ViewerPdf.vue?vue&type=template&id=52aaab5e&scoped=true"
import script from "./ViewerPdf.vue?vue&type=script&lang=ts"
export * from "./ViewerPdf.vue?vue&type=script&lang=ts"

import "./ViewerPdf.vue?vue&type=style&index=0&id=52aaab5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52aaab5e"

export default script